import { useCallback } from "react"
import type { PreOrderFlowSuggestion } from "@stockline/shared/types/ai/pre-order-flow-suggestion"
import { PRE_ORDER_FLOW_SUGGESTION_TABLE } from "../../../lib/offline/resources/ai/pre-order-flow-suggestion/db"
import { useAISync } from "../providers/AISyncProvider"

/** Resolution stamp the recap writes when a user accepts/declines. */
export type ResolvePreOrderFlowSuggestionInput = Partial<
  Pick<PreOrderFlowSuggestion, "acceptedAt" | "declinedAt" | "resolvedBy">
>

export function usePreOrderFlowSuggestionMutations() {
  const { storage, changeQueue, engine } = useAISync()

  const resolve = useCallback(
    async (
      id: string,
      input: ResolvePreOrderFlowSuggestionInput
    ): Promise<void> => {
      const existing = await storage.get<PreOrderFlowSuggestion>(
        PRE_ORDER_FLOW_SUGGESTION_TABLE,
        id
      )
      if (!existing) return
      const updated: PreOrderFlowSuggestion = {
        ...existing,
        ...input,
        updatedAt: new Date().toISOString(),
      }
      await storage.put(PRE_ORDER_FLOW_SUGGESTION_TABLE, updated)
      await changeQueue.enqueue("pre-order-flow-suggestions", {
        op: "update",
        id,
        data: input,
      })
      void engine.pushChanges("pre-order-flow-suggestions")
    },
    [storage, changeQueue, engine]
  )

  return { resolve }
}
